export enum ArchiveStatusType {
	ACTIVE = "Active",
	ARCHIVED = "Archived",
	ALL = "All"
}
